import(/* webpackMode: "eager" */ "/vercel/path0/dashboard/app/error.tsx");
